import { Button, FormControl, MessageBlock, Input } from '@deckee/deck-hand';
import React, { FC, useEffect, useState } from 'react';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { captureEvent } from '../../../../../services/event-capture';
import { useAppDispatch } from '../../../../../services/store';
import { selectCurrentMember } from '../../../../../services/store/modules/backend-service';
import { updateMemberContactInformation } from '../../../../../services/store/modules/plan';
import BasicDrawerLayout from '../../../../layouts/BasicDrawerLayout/BasicDrawerLayout';
import { LayoutBody } from '../../../../layouts/components/LayoutBody/LayoutBody';
import LogoSpinner from '../../../../shared/_deprecated/components/LogoSpinner/LogoSpinner';
import PhoneInput from '../PhoneInput/PhoneInput';

const UpdateMemberContactInformationPage: FC = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [contactNumber, setContactNumber] = useState('');
  const [fullName, setFullName] = useState('');
  const currentMember = useSelector(selectCurrentMember);

  useEffect(() => {
    if (currentMember) {
      setContactNumber(currentMember.phoneNumber);
      setFullName(currentMember.fullName);
    }
  }, [currentMember]);

  const handleSubmit = async () => {
    captureEvent({
      type: 'plan: click add emergency contact',
      payload: {},
    });

    try {
      setIsLoading(true);
      await dispatch(
        updateMemberContactInformation({
          fullName,
          phoneNumber: contactNumber,
        }),
      ).unwrap();
      history.goBack();
    } catch (e) {
      setError('Unable to save your phone number. Please try again soon');
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <BasicDrawerLayout heading="You" onBack={history.goBack}>
      <LayoutBody>
        {error && <MessageBlock type="error">{error}</MessageBlock>}

        {!error && isLoading && <LogoSpinner />}

        {!isLoading && (
          <>
            <FormControl label="Full name *">
              <Input
                placeholder="Full name"
                value={fullName}
                aria-label="full name"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setFullName(e.target.value)
                }
                required
              />
            </FormControl>
            <FormControl label="Phone number">
              <PhoneInput
                name="contactNumber"
                onChange={setContactNumber}
                value={contactNumber}
                defaultCountry="AU"
                aria-label="contact number"
                initialValueFormat="national"
                displayInitialValueAsLocalNumber
                limitMaxLength
              />
            </FormControl>
            <Button
              onClick={handleSubmit}
              wide
              disabled={
                fullName && contactNumber
                  ? !isValidPhoneNumber(contactNumber)
                  : true
              }
            >
              Save
            </Button>
          </>
        )}
      </LayoutBody>
    </BasicDrawerLayout>
  );
};

export default UpdateMemberContactInformationPage;
